import React from "react";
import { useLang } from "../../i18n/LanguageContext";

const Marquee = () => {
  const { t } = useLang();
  const items = t("marquee");
  if (!Array.isArray(items)) return null;
  const list = [...items, ...items, ...items];

  return (
    <section
      data-testid="marquee-section"
      className="py-12 md:py-16 border-y border-[#E5E5E5] overflow-hidden bg-[#F0EFEA]"
    >
      <div className="marquee">
        {list.map((it, i) => (
          <div key={i} className="flex items-center shrink-0 px-8 md:px-14">
            <span className="font-display text-2xl md:text-4xl text-[#111] whitespace-nowrap">
              {it}
            </span>
            <span className="ml-8 md:ml-14 inline-block w-3 h-3 bg-[#A89F91] rotate-45" />
          </div>
        ))}
      </div>
    </section>
  );
};

export default Marquee;
